import client from '../httpClient';

// 呼び出し元でローディング対象を切り替える
const libraryResisterApi = (params) => {
  return client.post('/libraries/management/', JSON.stringify(params), { isShowLoading: false });
};

export default libraryResisterApi;
